import React from 'react'
import injectStyles from 'react-jss'
import classNames from 'classnames'

import { QUIZ_QUESTION_TYPES } from '../../../../../shared/constants'

import styles from '../styles'
import StyledIconButton from '../../../../Form/StyledIconButton'
import { Input } from '../../../../Form/Input/index'
import RoundRadioButton from '../../../../../Assets/Images/icons/roundRadioButton'
import TrashCanFilled from '../../../../../Assets/Images/icons/trashCanFilled'
import { Typography } from '@material-ui/core'

const QuizQuestionItemView = ({
  onAddOption,
  type,
  cityId,
  onDeleteQuestion,
  description,
  classes,
  onQuestionChange,
  onQuestionTypeChange,
  isDisabled,
  children,
}) => {
  const {
    wrapper,
    columnsContainer,
    titleWrapper,
    itemsContainer,
    selectContainer,
    input,
    button,
    buttonsContainer,
    buttonAdd,
    disabledBlock,
    hint,
    inputWithUnderline,
    typeItem,
    typeItemText,
  } = classes

  return (
    <div className={wrapper}>
      {isDisabled && (
        <div className={hint}>Old questions cannot be edited, only deleted</div>
      )}
      <div
        className={classNames(columnsContainer, {
          [disabledBlock]: isDisabled,
        })}
      >
        <header className={titleWrapper}>
          {isDisabled ? (
            <Typography className={input}>{description}</Typography>
          ) : (
            <Input
              className={inputWithUnderline}
              onChange={e => onQuestionChange(e.target.value)}
              value={description}
              type="text"
              placeholder="Untitled question"
              inputClassName={inputWithUnderline}
            />
          )}
        </header>
        <section className={itemsContainer}>{children}</section>
        <section>
          {!isDisabled && (
            <StyledIconButton
              className={classNames(button, buttonAdd, {
                [disabledBlock]: isDisabled,
              })}
              onClick={onAddOption}
            >
              +
            </StyledIconButton>
          )}
        </section>
      </div>
      {cityId && (
        <div
          className={classNames(selectContainer, {
            [disabledBlock]: isDisabled,
          })}
        >
          {[
            {
              label: 'Multiple choice',
              value: QUIZ_QUESTION_TYPES.MULTIPLE_CHOICE,
            },
            {
              label: 'Single choice',
              value: QUIZ_QUESTION_TYPES.SINGLE_CHOICE,
            },
          ].map(item => {
            return (
              <div
                className={typeItem}
                onClick={() => onQuestionTypeChange(item.value)}
              >
                <div>
                  <RoundRadioButton active={item.value == type} />
                </div>
                <div className={typeItemText}>{item.label}</div>
              </div>
            )
          })}
        </div>
      )}
      <div className={buttonsContainer}>
        <div onClick={onDeleteQuestion}>
          <TrashCanFilled />
        </div>
      </div>
    </div>
  )
}

export default injectStyles(styles)(QuizQuestionItemView)
